import { Component, HostListener, NgZone } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { Item, ApiService } from './services/api.service';
import { UiModeService } from './services/ui-mode.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public imageURL: string = "https://keongkee.com.my/api/public/static";

  title = '强记海鲜';
  items: Array<Item>;

  deferredPrompt: any;
  showButton = false;

  isBeihai = false;
  isSelayang = false;
  isSetapak = false;

  isV2 = false;
  currentShop = 'selayang';
  version = '';

  constructor(private router: Router, private apiService: ApiService, private uiMode: UiModeService,
    private swUpdate: SwUpdate, private zone: NgZone) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isV2 = event.urlAfterRedirects.indexOf('/v2/') > -1;
      }
    });

    this.version = this.uiMode.version;

    this.setupAutoUpdate();

    this.goHome();
  }

  // When a new deployed version is detected, activate it and reload once
  // so customers always get the latest version without manual refresh.
  setupAutoUpdate() {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.available.subscribe(() => {
      this.swUpdate.activateUpdate().then(() => {
        document.location.reload();
      });
    });

    // Re-check every 30 minutes while the app stays open. Must run outside
    // the Angular zone: a zone timer keeps the app "unstable" forever, which
    // would block the service worker from ever registering on Angular 8.
    this.zone.runOutsideAngular(() => {
      setInterval(() => {
        this.swUpdate.checkForUpdate().catch(() => { });
      }, 30 * 60 * 1000);
    });
  }

  ngOnInit() {
    this.goHome();
  }

  goHome() {
    const myUrl = window.location.origin;

    console.warn("Accessing via: " + myUrl);

    if (myUrl.indexOf('beihai') > -1) {
      this.isBeihai = true;
      this.title = '北海海鲜酒家';

      this.go("beihai");
    } else if (myUrl.indexOf('selayang') > -1) {
      this.isSelayang = true;
      this.title = '强记海鲜酒家 (士拉央)';

      this.go("selayang");
    } else if (myUrl.indexOf('setapak') > -1) {
      this.isSetapak = true;
      this.title = '强记海鲜酒家 (文良港)';

      this.go("setapak");
    } else {
      // Default to selayang
      this.isSelayang = true;
      this.title = '强记海鲜酒家 (士拉央)';

      this.go("selayang");
    }
  }

  go(destination) {
    this.currentShop = destination;

    // Keep v2 deep links (e.g. refreshing or sharing /v2/dishes) instead of resetting to home
    if (window.location.pathname.indexOf('/v2/') === 0) {
      return;
    }

    if (this.uiMode.isV2()) {
      this.router.navigate(['/v2/menu'], { queryParams: { 'shop': destination } });
    } else {
      this.router.navigate(['/menu'], { queryParams: { 'shop': destination } });
    }
  }

  tryNewUi() {
    this.uiMode.setMode('v2');
    this.router.navigate(['/v2/menu'], { queryParams: { 'shop': this.currentShop } });
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    console.log(e);
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showButton = true;
  }

  addToHomeScreen() {
    // hide our user interface that shows our A2HS button
    this.showButton = false;
    // Show the prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
      });
  }
}